export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validatePassword(password: string): boolean {
  if (typeof password !== "string") return false;
  return password.length >= 8 && /(?=.*[a-zA-Z])(?=.*\d)/.test(password);
}

export function validateUsername(username: string): boolean {
  return /^[a-zA-Z0-9_]{3,20}$/.test(username);
}

export function validateUrl(url: string): boolean {
  try {
    if (!url || url.trim() === "") return false;
    const urlObj = new URL(url.trim());
    return urlObj.protocol === "http:" || urlObj.protocol === "https:";
  } catch {
    return false;
  }
}
